import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const button = css`
  margin-top: ${size[24]};

  ${breakpoint.up('sm')} {
    margin-top: ${size[32]};
  }
`
